import React, {
    useCallback,
    useEffect,
    useState,
    useMemo,
    useRef,
} from 'react';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';

import PropTypes from 'prop-types';
import { format, formatISO, parseISO } from 'date-fns';
import { isEmpty, isArray } from 'lodash';
import qs from 'querystring';
import axios from 'axios';
import * as Yup from 'yup';

import { Table } from '~/components';
import { TableSearchListdDef } from '~/componentslocal';
import { RadioGroup, Input, DateTime } from '~/components/Form';
import { t, number, parseDateString } from '~/helpers';
import api from '~/services/api';
import { SelectComplete } from '~/componentslocal'
import { cancelarVazamento } from '~/store/modules/manutExcluirVazamento/actions';
import * as S from './styles';

export default function RecordDetails({
    data,
    sending,
    visible,
    toggleDisabled,
    close
}) {


    const currentDate = useMemo(() => format(new Date(), 'dd/MM/yyyy HH:mm'), [])
    const dispatch = useDispatch();

    const [dataTable, setDataTable] = useState([])
    const { username } = useSelector(state => state.user.profile)
    const { params } = useSelector((state) => state.manutExcluirVazamento);
    const formRef = useRef(null);


    useEffect(() => {
        if (!isEmpty(data))
            handleGetData(data)
    }, [data])


    const handleGetData = useCallback(async (values) => {
        let params = {
            wherefield: ['turn_cod_turn', 'post_cod_posto', 'tipoRel'],
            valuewherefield: [values.turn_cod_turn, values.post_cod_posto, 2],
            typewherefield: ['EQUALS', 'EQUALS', 'EQUALS']

        }

    }, [])

    const handleSubmit = useCallback(async (param) => {
        try {
            toggleDisabled(true)
            const schema = Yup.object().shape({
                msg: Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
                    .matches(/^[a-zA-ZÁ-ú0-9:?!@$%,-.+()\\[\] ]+$/, 'Caractere(s) inválido(s)'),
                user: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),

            });


            await schema.validate(param, {
                abortEarly: false,
            });


            let objSend = {
                rCodigo: data.abas_cod_abas,
                rMaag_Tabela: 'ABASTECIMENTO',
                rMata_Cod_Mata: 5,
                rMaag_Num_Tar_Exec: 3,
                rMaag_Chave: `(POST_COD_POSTO = &#183${data.post_cod_posto}&#183  AND ABAS_COD_ABAS = ${data.abas_cod_abas})`,
                rPost_Cod_Posto: data.post_cod_posto,
                rBico_cod_bico: data.bico_cod_bico.toString(),
                rTurn_cod_turn: data.turn_cod_turn,
                rMaag_Obs: param.msg,
                rMaag_Usua_Sol: param.user,
                rMaag_Usua_Inc: username,
                rNewEmpe_Cod_Emp: '',
                rNewVeic_Cod_Veic: '',
                rNewMoto_cod_moto: '',
                rNewEnvia_Unilog: '',
                rAtualAbas_Vol_Amb: data.abas_vol_amb,
                rAtualAbas_Vol_Ref: data.abas_vol_ref,
                rAtualAbas_Vol_20: data.abas_vol_20,
                rNF_AlterarVolumes: 'N',
                rNewNumPedido: '',
                rNewNumNfRvt: '',
                rNewNumCTVT: '',
                rNewDataEmissaoNF: '01/01/2021',
                rAtualVolNF: 0.0,
                rAtualVol20NF: 0.0,
                rAtualTemperaturaNF: 0.0,
                rAtualDensidadeNF: 0.0,
                rOldVolNF: 0.0,
                rOldVol20NF: 0.0,
            }

            await dispatch(cancelarVazamento(objSend, params))
            toggleDisabled(false)
            close();

        } catch (err) {
            toggleDisabled(false)
            const validationErrors = {};
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message.replace(
                        `${error.path} `,
                        ''
                    );
                });
                formRef.current.setErrors(validationErrors);
            } else {
                toast.error(err)
            }
        }
    }, [data, username, params])









    useEffect(() => {
        if (sending) formRef.current.submitForm();
    }, [sending]);

    return (
        <>
            {!isEmpty(data) && <S.Wrapper
                ref={formRef}
                initialData={{
                    ...data,
                    datahora: format(new Date(data.abas_datahora_ini), 'dd/MM/yyyy HH:mm:ss'),
                }}
                onSubmit={handleSubmit}
            >
                <Input name="post_desc" label="Posto" disabled />
                <DateTime
                    time
                    name="datahora"
                    label="Data"
                    disabled
                />
                <Input name="bico_cod_bico" label="Bico" disabled />
                <Input name="abas_vol_amb" label="Volume" disabled />
                <Input name="abas_encer_ini" label="Enc. Inícial" disabled />
                <Input name="abas_encer_fim" label="Enc. Final" disabled />
                <SelectComplete
                    name="user"
                    title="Usuário Solicitante"
                    label="usua_nome"
                    unique="usua_cod_usua"
                    url="usuario"
                />
                <Input name="msg" label="MSG" multiline rows={7} inputProps={{ maxLength: 500 }} />

            </S.Wrapper >}
        </>

    );
}

RecordDetails.propTypes = {
    data: PropTypes.objectOf(PropTypes.any).isRequired,
    sending: PropTypes.bool.isRequired,
    visible: PropTypes.bool.isRequired,
    toggleDisabled: PropTypes.func.isRequired,
};
